module.exports = __webpack_public_path__ + "img/frontpage-team.93c63d04.png";